function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: "100%",
  height: "100%",
  fill: "#11365f"
});

function SvgMoreViewsClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _ref, /*#__PURE__*/React.createElement("path", {
    style: {
      isCustomFont: "none",
      fontFileUrl: "none"
    },
    vectorEffect: "non-scaling-stroke",
    d: "M30 18a12 12 0 100 24 12 12 0 000-24zm5.884 15.15a.581.581 0 010 .823l-1.92 1.911a.58.58 0 01-.822 0L30 32.71l-3.15 3.174a.581.581 0 01-.822 0l-1.911-1.92a.58.58 0 010-.822L27.29 30l-3.174-3.15a.58.58 0 010-.822l1.92-1.92a.58.58 0 01.822 0L30 27.29l3.15-3.174a.58.58 0 01.823 0l1.92 1.92a.581.581 0 010 .822L32.71 30l3.174 3.15z",
    fill: "#fff"
  }));
}

export default SvgMoreViewsClose;